module.exports = __webpack_public_path__ + "img/service-item-3.3561e08b.jpeg";